import * as type from '../actions/types';

const initialState = {
    loading: false,
    error: null,
}

export default function markCancelProject(state = initialState, action) {
    switch (action.type) {
        case type.POST_PROJECT_CANCEL_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.POST_PROJECT_CANCEL_SUCCESS:
            return {
                ...state,
                loading: false,
            }
        case type.POST_PROJECT_CANCEL_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}